import React from "react";
import Home from './Home'
import Commscope from './components/commscope/commscope'
import Edusera from './components/edusera/edusera'
import Devtown from './components/devtown/devtown'
import CertHandler from "./components/certificationsHandler/CertHandler"
import SkillsHandler from "./components/skillsHandler/skillsHandler"
import AdminActions from "./components/AdminActions/AdminActions"
import Admin from "./components/Admin/Admin"
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom'
function App(){
    return (
        <Router >
            <Routes>
                <Route exact path="/" element={<Home/>}/>
                <Route exact path="commscope" element={<Commscope/>}/>
                <Route exact path="edusera" element={<Edusera/>}/>
                <Route exact path="devtown" element={<Devtown/>}/>
                <Route exact path="admin" element={<Admin/>}/>
                <Route exact path="uploadcertifications" element={<CertHandler/>}/>
                <Route exact path="addskill" element={<SkillsHandler/>}/>
                <Route exact path="adminactions" element={<AdminActions/>}/>
            </Routes>
        </Router>
    )
}

export default App;